import api from '@/services/api';
import type { Faculty, FacultyInput } from '@/types/faculty_schema';

const BASE_URL = '/university/faculties';

export const facultyApi = {
  /**
   * Get all faculties
   */
  getAllFaculties: async (params?: {
    page?: number;
    per_page?: number;
    search?: string;
    is_active?: boolean;
  }) => {
    return api.get<{ data: Faculty[]; meta?: any }>(BASE_URL, { params });
  },

  /**
   * Get a single faculty by ID
   */
  getFacultyById: async (id: string) => {
    return api.get<{ data: Faculty }>(`${BASE_URL}/${id}`);
  },

  /**
   * Create a new faculty
   */
  createFaculty: async (input: FacultyInput) => {
    return api.post<{ data: Faculty }>(BASE_URL, input);
  },

  /**
   * Update an existing faculty
   */
  updateFaculty: async (id: string, input: Partial<FacultyInput>) => {
    return api.put<{ data: Faculty }>(`${BASE_URL}/${id}`, input);
  },

  /**
   * Delete a faculty
   */
  deleteFaculty: async (id: string) => {
    return api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * Get faculty statistics
   */
  getFacultyStats: async (id: string) => {
    return api.get<{ data: { department_count: number; program_count: number; student_count: number } }>(
      `${BASE_URL}/${id}/stats`
    );
  },
};

export default facultyApi;
